import React from "react"
import { Box, BoxProps } from "@chakra-ui/react"

/**
 * Checkerboard background inside a bordered, rounded frame — useful for
 * previewing images with transparency (e.g. PNG logos).
 */
const CHECKERBOARD_PATTERN = `
  linear-gradient(
    45deg,
    rgba(160, 174, 192, 0.22) 25%,
    transparent 25%,
    transparent 75%,
    rgba(160, 174, 192, 0.22) 75%,
    rgba(160, 174, 192, 0.22)
  ),
  linear-gradient(
    45deg,
    rgba(160, 174, 192, 0.22) 25%,
    transparent 25%,
    transparent 75%,
    rgba(160, 174, 192, 0.22) 75%,
    rgba(160, 174, 192, 0.22)
  )
`

type Props = Omit<BoxProps, "children"> & { children: React.ReactNode }

const CheckeredFrame = ({ children, ...rest }: Props) => (
  <Box
    display="inline-block"
    lineHeight={0}
    borderRadius="md"
    overflow="hidden"
    borderWidth={1}
    borderStyle="solid"
    borderColor="gray.400"
    backgroundColor="white"
    backgroundImage={CHECKERBOARD_PATTERN}
    backgroundSize="16px 16px"
    backgroundPosition="0 0, 8px 8px"
    {...rest}
  >
    {children}
  </Box>
)

export default CheckeredFrame
